import { IconFileEdit16 } from '@cian/ui-kit-design-tokens/icons';

import * as React from 'react';

import { MenuItem } from '../../../components/SavedSearches/MobileComponents/MenuItem';

export interface IEditActionContainerProps {
  onClick(): void;
}

export const EditActionContainer: React.FC<IEditActionContainerProps> = ({ onClick }) => {
  return <MenuItem icon={<IconFileEdit16 color="icon-secondary-default" />} label="Редактировать" onClick={onClick} />;
};
